import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Play"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-play',
    templateUrl: './icon-play.component.html',
    styleUrls: ['./icon-play.component.scss'],
    standalone: false
})
export class IconPlayComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
